const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Date range", "uipress-lite"),
  moduleName: "uip-date-range",
  description: __("Outputs a date range input. Can be a single date, date range, or a comparison date range", "uipress-lite"),
  group: "form",
  icon: "date_range",
};
